module.exports = __webpack_public_path__ + "img/hopways-02.07e800f6.webp";